// /**
//  * Orders - list
//  */

// React
import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';

// Context
import AuthContext from '../../../authContext';

// UI
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Chip,
} from '@material-ui/core';

// Components
import Can from '../../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../../utils/rulesOrderStatus';

import {translate, checkMatchMedia} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import {Order, Status} from '../../orders/interfaces';
import stableSort from '../../../utils/Table/stableSort';
import getComparator from '../../../utils/Table/getComparator';
import RonadIcons from '../../../components/iconComponent';
import SimpleTable, { TheadProps, TbodyProps } from '../../../components/Table/simpleTable';
import SimpleTableBody from '../../../components/Table/tableBody';
import SimpleTableHead from '../../../components/Table/tableHead';

type Data = Order;
type Props = {
  data: any;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      textAlign: 'left',
      padding: '10px 0',

      backgroundColor: '#D5DADD !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      textAlign: 'left',
      padding: '10px 10px',
      borderRadius: '0',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      borderRadius: '4px',
      boxShadow: '0 0 24px -8px rgba(0,0,0,0.27)',
    },
    hover: {
      '&:hover': {
        backgroundColor: '#F8F9FA !important',
      },
    },
    fromRonad: {
      backgroundColor: '#b8c6e3',
      color: '#fff !important',
      '&:hover': {
        backgroundColor: '#8b99b5',
      },
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 750,
      borderRadius: '4px',
      boxShadow: '-4px 4px 12px 5px rgba(0,0,0,0.06)',
      border: '1px solid #d5dadd',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const {numSelected, selected, data} = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 ? (
            <Tooltip title="تغییر وضعیت">
              <Button
                size="small"
                variant="contained"
                onClick={handleClickChangeStatus}
                color="secondary"
              >
                تغییر وضعیت
              </Button>
            </Tooltip>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ticketPriority = {
  LOW: {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  NORMAL: {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  HIGH: {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  CRITICAL: {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
};


const statusMap = {
  FFC_FFC_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  FFC_SUPPORT_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  PARTNER_FFC_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  PARTNER_SUPPORT_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  PARTNER_PARTNER_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  FFC_FFC_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  FFC_SUPPORT_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  PARTNER_FFC_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  PARTNER_SUPPORT_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  PARTNER_PARTNER_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  FFC_FFC_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  FFC_SUPPORT_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  PARTNER_FFC_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  PARTNER_SUPPORT_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  PARTNER_PARTNER_SUPPORT_OWNER_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  SUPPORT_FFC_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی', 
  SUPPORT_PARTNER_SUPPORT_OPEN: 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  SUPPORT_FFC_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_SUPPORT_PENDING: 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_PARTNER_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_FFC_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_PARTNER_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_FFC_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_PARTNER_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_FFC_FFC_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  SUPPORT_FFC_PARTNER_ASSIGNEE_ANSWERED: 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_FFC_ASSIGNEE_ANSWERED : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_FFC_OPEN : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_FFC_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_PARTNER_OPEN : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_PARTNER_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_SUPPORT_ASSIGNEE_ANSWERED : 'نیاز به بررسی پشتیبانی',
  SUPPORT_PARTNER_SUPPORT_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_PARTNER_OPEN : 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_PARTNER_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_SUPPORT_ASSIGNEE_ANSWERED : 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_FFC_OPEN : 'نیاز به بررسی پشتیبانی',
  FFC_PARTNER_FFC_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  FFC_SUPPORT_PARTNER_OPEN: 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED : 'نیاز به بررسی پشتیبانی',
  SUPPORT_SUPPORT_SUPPORT_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  PARTNER_PARTNER_PARTNER_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  PARTNER_PARTNER_FFC_OWNER_ANSWERED : 'نیاز به بررسی پشتیبانی',
  PARTNER_FFC_FFC_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_FFC_SUPPORT_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_FFC_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  FFC_FFC_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  FFC_SUPPORT_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  SUPPORT_FFC_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  SUPPORT_SUPPORT_PARTNER_OWNER_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  SUPPORT_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_PARTNER_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_FFC_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  FFC_SUPPORT_PARTNER_PENDING: 'در انتظار پاسخ مشتری',
  PARTNER_SUPPORT_PARTNER_ASSIGNEE_ANSWERED: 'در انتظار پاسخ مشتری',
  PARTNER_PARTNER_PARTNER_CLOSED: 'بسته شده',
  PARTNER_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_PARTNER_FFC_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_SUPPORT_FFC_CLOSED: 'بسته شده',
  PARTNER_FFC_PARTNER_CLOSED: 'بسته شده',
  PARTNER_FFC_SUPPORT_CLOSED: 'بسته شده',
  PARTNER_FFC_FFC_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_PARTNER_FFC_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_SUPPORT_FFC_CLOSED: 'بسته شده',
  SUPPORT_FFC_PARTNER_CLOSED: 'بسته شده',
  SUPPORT_FFC_SUPPORT_CLOSED: 'بسته شده',
  SUPPORT_FFC_FFC_CLOSED: 'بسته شده',
  FFC_PARTNER_PARTNER_CLOSED: 'بسته شده',
  FFC_PARTNER_SUPPORT_CLOSED: 'بسته شده',
  FFC_PARTNER_FFC_CLOSED: 'بسته شده',
  FFC_SUPPORT_PARTNER_CLOSED: 'بسته شده',
  FFC_SUPPORT_SUPPORT_CLOSED: 'بسته شده',
  FFC_SUPPORT_FFC_CLOSED: 'بسته شده',
  FFC_FFC_PARTNER_CLOSED: 'بسته شده',
  FFC_FFC_SUPPORT_CLOSED: 'بسته شده',
  FFC_FFC_FFC_CLOSED: 'بسته شده',
  FFC_FFC_FFC_PENDING: 'نیاز به بررسی',
  FFC_SUPPORT_FFC_PENDING: 'نیاز به بررسی',
  FFC_PARTNER_FFC_PENDING: 'نیاز به بررسی',
  SUPPORT_PARTNER_FFC_PENDING: 'نیاز به بررسی',
  SUPPORT_SUPPORT_FFC_PENDING: 'نیاز به بررسی',
  SUPPORT_FFC_FFC_PENDING: 'نیاز به بررسی',
  PARTNER_SUPPORT_FFC_PENDING: 'نیاز به بررسی',
  PARTNER_PARTNER_FFC_PENDING: 'نیاز به بررسی',
  PARTNER_FFC_FFC_PENDING: 'نیاز به بررسی',
  SUPPORT_SUPPORT_FFC_OWNER_ANSWERED : 'نیاز به بررسی',
  PARTNER_SUPPORT_FFC_OWNER_ANSWERED : 'نیاز به بررسی',
  FFC_SUPPORT_FFC_ASSIGNEE_ANSWERED : 'نیاز به بررسی',
  FFC_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED : 'نیاز به بررسی',
  SUPPORT_SUPPORT_PARTNER_OPEN : 'ایجاد شده' ,
  SUPPORT_SUPPORT_FFC_OPEN : 'ایجاد شده' ,
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const {
    order,
    orderBy,
    onRequestSort,
    numSelected,
    rowCount,
    onSelectAllClick,
  } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  let headCells: HeadCell[] = [];

  headCells = [
    {
      id: 'tracking',
      label: 'شماره تیکت',
    },
    {
      id: 'linkId',
      label: 'شناسه سفارش یا محموله',
    },
    {id: 'creatorId', label: 'از/به'},
    {id: 'category', label: 'دسته‌بندی'},
    {id: 'subject', label: 'موضوع'},
    {id: 'title', label: 'عنوان'},
    {id: 'status', label: 'وضعیت'},
    {id: 'importance', label: 'اولویت'},
    {id: 'createdAt', label: 'تاریخ ایجاد'},
    {id: 'updatedAt', label: 'آخرین بروزرسانی'},
  ];

  return (
    <TableHead>
      <TableRow style={{borderRadius: '0'}}>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <RonadIcons
                  name={
                    orderBy === headCell.id && order === 'desc'
                      ? 'chevron-down'
                      : 'chevron-up'
                  }
                  size="18px"
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}
const headCells = [
  {
    id: 'tracking',
    label: 'شماره تیکت',
    align: 'center',
    format: row => (<>
      <RonadIcons
          name="circle"
          size="14px"
          fill={row.seen === '1' ? '#87FF93' : '#ec4040'}
          color='none'
        />
        &nbsp; &nbsp; &nbsp;
        <span>{row.tracking}</span>
      </>
    )
  },
  {
    id: 'linkId',
    label: 'شناسه',
    format: row => (
      <Link
        to={row.linkType === 'order' ? `/orders/${row.linkId}` : `/parcels/details/${row.linkId}`}
      >
        {row.linkId}
      </Link>
    )
  },
  {
    id: 'partner',
    label: 'پارتنر',
    align: 'center',
    format: row => (
      <span>{row?.partner?.names +' - '+ row?.partner?.id }</span>
    )
  },
  {
    id: 'creatorId', 
    label: 'ایجاد کننده',
    format: row => (
      <span>{row?.creator?.username}</span>
    )
  },
  {
    id: 'assigneeId', 
    label: 'دردست',
    format: row => (
      <span> {row?.assignee?.username} ({row?.department?.name})</span>
    )
  },
  // {
  //   id: 'editorId', 
  //   label: 'آخرین ویرایش کننده',
  //   format: row => (
  //     <span>{ row?.editor?.username}</span>
  //   )
  // },
  {
    id: 'category', 
    label: 'دسته‌بندی',
    format: row => (
      <span>{row.category.name}</span>
    )
  },
  {
    id: 'subject', 
    label: 'موضوع',
    format: row => (
      <span>{row.subject && row.subject.body}</span>
    )
  },
  {
    id: 'title', 
    label: 'عنوان'
  },
  {
    id: 'status', 
    label: 'وضعیت',
    format: row => (
      <span>{statusMap[row.fullStatus]}</span>
    )
  },
  // {
  //   id: 'importance', 
  //   label: 'اولویت',
  //   format: row => (
  //     <Chip
  //       icon={
  //         <RonadIcons
  //           name="circle"
  //           size="14px"
  //           fill={ticketPriority[row.priority]?.color}
  //           color='none'
  //         />
  //       }
  //       // label={
  //       //   ticketPriority[row.priority]?.title
  //       // }
  //       style={{
  //         color: ticketPriority[row.priority]?.color,
  //         backgroundColor: ticketPriority[row.priority]?.bcolor,
  //         fontSize: '16px',
  //       }}
  //     />
  //   )
  // },
  {
    id: 'createdAt', 
    label: 'ایجاد',
    format: row => (
      <>
        <span>
          {`${jMoment(row.createdAt.split('T')[1], 'HH:mm:ss')
            .add(3, 'hours')
            .add(30, 'minutes')
            .locale('fa')
            .format('HH:mm')}
            `}
        </span>
        &nbsp;
        <span>
          {jMoment(row.createdAt, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD')}
        </span>
      </>
    )
  },
  {
    id: 'updatedAt', 
    label: 'بروزرسانی',
    format: row => (
      <>
        <span>
          {`${jMoment(row?.updatedAt?.split('T')[1], 'HH:mm:ss')
            .add(3, 'hours')
            .add(30, 'minutes')
            .locale('fa')
            .format('HH:mm')}
            `}
        </span>
        &nbsp;
        <span>
          {jMoment(row.updatedAt, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD')}
        </span>
      </>
    )
  },
];

const action = (row: any) => (<>
  <div>
    <Link to={`/ticketing/${row.id}`}>
      <RonadIcons className='mr-2 text-green' name='file-05' title="جزئیات سفارش"/>
    </Link>
  </div>
</>)

export default function EnhancedTable(props: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SimpleTable
        defaultOrderBy="updatedAt"
        Thead={
          (prop: TheadProps) => (<SimpleTableHead
            headCells={headCells}
            action={action}
            {...prop}
          />)
        }
        Tbody={(prop: TbodyProps) => (<SimpleTableBody 
          celles={headCells}
          data={props.data}
          action={action}
          {...prop}
        />)}
      />
    </div>
  );
}
